<template>
<div class="mOrderListPaying" v-if="init">
    <pull :pull="pull" :page="page" @getList="getList">
        <NoData v-if="!orderList.length"></NoData>
        <MDataList :orderList="orderList" v-else></MDataList>
    </Pull>
</div>
</template>

<script>
import MDataList from 'views/mobile/my/order/components/mDataList'
import {mapActions, mapGetters} from 'vuex'
import Pull from 'views/mobile/components/pull/pull'
import NoData from 'views/mobile/components/noData/noData'
import {getOrderList} from 'api/systemApi'

export default {
    name: 'mOrderListPaying',
    data() {
        return {
            init: false,
            param: {
                status: '9'
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            orderList: []
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            this.setLoading(true)
            getOrderList({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    this.init = true
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.orderList = data.data.content
                    } else {
                        this.orderList = this.orderList.concat(data.data.content)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {
        MDataList, Pull, NoData
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.mOrderListPaying  {
}
</style>